import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postGlottisLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/backend_helper";
import toast from "react-hot-toast";
import { clearToken, setToken } from '../../../helpers/api_helper';

// const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history, redirectUrl } }) {
  try {

    const response = yield call(postGlottisLogin, {
      email: user.email,
      password: user.password,
    }); 
    if (response.status === "success") {
      toast.success(response.message); 
      localStorage.setItem("jwt", response.token);
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response.message));
      setToken()
      if (redirectUrl) {
        history.push(`${redirectUrl}`);
        sessionStorage.removeItem("redirectUrl");
      } else {
        history.push("/dashboard");
      }
        
    } else if (response.status === "error") {
      toast.error(response.message);
      yield put(loginSuccess(response.message));
    } else {
      toast.error(response.message);
      yield put(apiError(response.message));
    }
  } catch (error) { 
    toast.error(error.response.data.message,{duration: 6000})
    yield put(apiError(error.response.data.message));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("jwt");
    localStorage.removeItem("authUser");
    clearToken();
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
